import 'keen-slider/keen-slider.min.css';
import { CommonPropsWithChildren, withNativeProps } from '../utils/native-props';
import './style.less';

export type SwiperItemProps = {} & CommonPropsWithChildren;

export const SwiperItem = (props: SwiperItemProps) => {
  return withNativeProps(props, <div className="keen-slider__slide">{props.children}</div>);
};
